import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import TitleNode from "../../../InvestmentOptions/Components/InvestmentAllocationCard/TitleNode/TitleNode";
import FlowCard from "../../../InvestmentOptions/Components/InvestmentAllocationCard/FlowCard/FlowCard";
import { DataValue } from "../../../InvestmentOptions/Components/InvestmentAllocationCard/styles";
import formatter from "../../../../../../../../utils/formatter";
import {Triangle} from "../InvestmentTable/styles";
import UpArrow from "../../../../../../../../assets/icons/caret-up.png";
import DownArrow from "../../../../../../../../assets/icons/caret-down.png";
import { replacer, decodeName } from "../../../../../../../../utils/nameFormatter";
import { investmentAllocationCardStep3State } from "../../../../selectors";
import { replaceSelect } from "../../../../../../../../utils/replacer";

let formData = [];

class GrantAllocationCard extends Component {

  constructor(props) {
    super(props);
    this.renderTitleGrid = this.renderTitleGrid.bind(this);
    this.renderFixGrid = this.renderFixGrid.bind(this);
    this.renderAvailableBalance = this.renderAvailableBalance.bind(this);
    this.renderPricePerUnit = this.renderPricePerUnit.bind(this);
    let updatedPoolData = this.props.accountData; 
  updatedPoolData.portfolioBuilders && updatedPoolData.portfolioBuilders.map((option) => formData.push(option));
  updatedPoolData.portfolioSolutions && updatedPoolData.portfolioSolutions.map((option) => formData.push(option));
  updatedPoolData.valueDriven && updatedPoolData.valueDriven.map((option) => formData.push(option));
  }

  renderTitleGrid(text) {
    return <DataValue>{replaceSelect(decodeName(Object.keys(text)[0]))}</DataValue>;
  }

  renderFixGrid(text) {
    return (
      <>
        <TitleNode title="Percentage" />
        <DataValue>
        {formatter({
      value: text[Object.keys(text)[0]]["Percentage"],
      fieldSuffix: "Percentage",
    })}
        </DataValue>
      </>
    );
  }

  renderAvailableBalance(text) {
    const aB = formData.filter((pool) => {
      if (replacer(pool.investmentOption) === Object.keys(text)[0]) {
        return true;
      }
    });
    return (
    <>
    <TitleNode title="Available Balance" />
    {aB.length > 0 ?
    <DataValue>{aB[0].availableBalance ? formatter({"value": aB[0].availableBalance,"fieldSuffix": 'Dollars'})
    : <div>&mdash;</div>
      }</DataValue>
      :
      <DataValue><div>&mdash;</div></DataValue>
    }
    </>
    )
  }

  renderPricePerUnit(text) {
    const aB = formData.filter((pool) => {
      if (replacer(pool.investmentOption) === Object.keys(text)[0]) {
        return true;
      }
    });
    return (
    <>
    <TitleNode title="Price Per Unit" />
    {aB.length > 0 ?
    <DataValue>{aB[0].currentNav ?  <span>{formatter({
      value: aB[0].currentNav,
      fieldSuffix: 'Dollars',
    })} <Triangle alt={(aB[0].rise === false) ? "fall" : "rise"} src={(aB[0].rise === false) ? DownArrow : UpArrow} /> </span>
    : <div>&mdash;</div>
      }</DataValue>
      :
      <DataValue><div>&mdash;</div></DataValue>
    }
    </>
    )

  }

   styleConfig() {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardDivider: true,
      cardPadding: true,
    };
  }

   destObj(pool, index) {
    return [
      {
        name: 'name',
        gridWidth: '100',
        type: 'TitleGrid',
        render: this.renderTitleGrid(pool),
        noBorderBottom: true,
        ptop: true,
      },
      {
        name: 'availableBalance',
        gridWidth: '50',
        type: 'FixGrid',
        render: this.renderAvailableBalance(pool),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'pricePerUnit',
        gridWidth: '50',
        type: 'FixGrid',
        render: this.renderPricePerUnit(pool),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'Percentage',
        type: 'FixGrid',
        gridWidth: '100',
        render: this.renderFixGrid(pool),
        ptop: true,
        pbottom: true,
        pleft: true,
      }
    ];
  }

  createTableDataSource(poolData) {
    const arr = [];
    let updatedData = poolData;
    for (const pool in updatedData.portfolioBuildersForm) {
      if (Object.prototype.hasOwnProperty.call(updatedData.portfolioBuildersForm, pool)) {
        if(updatedData.portfolioBuildersForm[pool]["Percentage"] > 0 )
        arr.push({ [pool]: updatedData.portfolioBuildersForm[pool] });
      }
    }
    for (const pool in updatedData.portfolioSolutionsForm) {
        if (Object.prototype.hasOwnProperty.call(updatedData.portfolioSolutionsForm, pool)) {
          if(updatedData.portfolioSolutionsForm[pool]["Percentage"] > 0 )
          arr.push({ [pool]: updatedData.portfolioSolutionsForm[pool] });
        }
    }
    for (const pool in updatedData.valueDrivenForm) {
        if (Object.prototype.hasOwnProperty.call(updatedData.valueDrivenForm, pool)) {
          if(updatedData.valueDrivenForm[pool]["Percentage"] > 0 )
          arr.push({ [pool]: updatedData.valueDrivenForm[pool] });
        }
    }
   
    return arr;
  }

render(){
  const { formData } = this.props;
  let combinedData = this.createTableDataSource(formData); 
  return (
    <>
      {combinedData.map((pool, index) => (
        <FlowCard
          cardConfig={this.destObj(pool, index)}
          styleConfig={this.styleConfig()}
          index={index}
          scrollId="fromFlowCard"
        />
      ))}
      
    </>
  );
}
}

GrantAllocationCard.propTypes = {
  accountData: PropTypes.object,
  formData: PropTypes.object,
}

const mapStateToProps = state => ({
  ...investmentAllocationCardStep3State(state.toJS())
});

export default connect(
  mapStateToProps,
  null,
)(GrantAllocationCard);
